import { Tabs, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { InvoiceStatusEnum } from 'src/shared/models/enums/invoiceStatusEnum';

interface InvoiceTabsProps {
  initialValue: InvoiceTabItem | undefined;
  disableAll: boolean;
  callback: (item: InvoiceTabItem) => void;
  includeSentStatusTabs?: boolean;
}

export interface InvoiceTabItem {
  label: string;
  key: string;
  values: number[];
  isSent?: boolean;
}

export const invoiceTabs: InvoiceTabItem[] = [
  {
    label: 'invoice:invoiceTabs.All',
    key: 'All',
    values: [],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.Paid',
    key: 'Paid',
    values: [InvoiceStatusEnum.Paid],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.UnPaid',
    key: 'UnPaid',
    values: [InvoiceStatusEnum.UnPaid],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.PartlyPaid',
    key: 'PartlyPaid',
    values: [InvoiceStatusEnum.PartlyPaid],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.Overdue',
    key: 'Overdue',
    values: [InvoiceStatusEnum.Overdue],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.Canceled',
    key: 'Canceled',
    values: [InvoiceStatusEnum.Canceled],
    isSent: undefined,
  },
  {
    label: 'invoice:invoiceTabs.Sent',
    key: 'Sent',
    values: [],
    isSent: true,
  },
  {
    label: 'invoice:invoiceTabs.NotSent',
    key: 'NotSent',
    values: [],
    isSent: false,
  },
];

const InvoiceTabs = ({ initialValue, disableAll, callback, includeSentStatusTabs = false }: InvoiceTabsProps) => {
  ConsoleHelper.log('initialValue', initialValue);
  const [value, setValue] = React.useState(initialValue ? initialValue.key : 'UnPaid');
  const { t } = useTranslation(['invoice']);

  const filteredTabs = includeSentStatusTabs ? invoiceTabs : invoiceTabs.filter((tab) => tab.key !== 'Sent' && tab.key !== 'NotSent');

  const handleChange = (event: React.ChangeEvent<any>, newValue: string) => {
    setValue(newValue);
    callback(invoiceTabs.filter((x) => x.key === newValue)[0]);
  };

  return (
    <Tabs
      value={value}
      textColor='primary'
      onChange={handleChange}
      aria-label='status-tabs'
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {filteredTabs.map((item) => (
        <Tab key={item.key} label={t(item.label)} value={item.key} disabled={disableAll} />
      ))}
    </Tabs>
  );
};

export default InvoiceTabs;
